import { createContext } from 'react';
import noop from '../../utils/noop';
export default createContext(noop);